var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ApiProxy {
    constructor(authent, prefix, log = false) {
        this.authent = authent;
        this.prefix = prefix;
        this.log = log;
        this.post = (endpoint, data, hasResponseBody = true, auth = true) => __awaiter(this, void 0, void 0, function* () {
            return hasResponseBody
                ? this.withBody(endpoint, data, auth, 'POST')
                : this.withBodyNoOut(endpoint, data, auth, 'POST');
        });
        this.put = (endpoint, data, hasResponseBody = true, auth = true) => __awaiter(this, void 0, void 0, function* () {
            return hasResponseBody
                ? this.withBody(endpoint, data, auth, 'PUT')
                : this.withBodyNoOut(endpoint, data, auth, 'PUT');
        });
        this.get = (endpoint, auth = true, params) => __awaiter(this, void 0, void 0, function* () { return this.withoutBody(endpoint, auth, 'GET', params); });
        this.delete = (endpoint, auth = true) => __awaiter(this, void 0, void 0, function* () { return this.withoutBody(endpoint, auth, 'DELETE'); });
        this.formData = (endpoint, fd, onProgress) => {
            return new Promise((res, rej) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', `${this.prefix}${endpoint}`);
                const headers = [...this.makeHeaders(true)];
                headers.forEach(v => {
                    if ('content-type' !== v[0])
                        xhr.setRequestHeader(v[0], v[1]);
                });
                xhr.onload = () => res(JSON.parse(xhr.responseText));
                xhr.onerror = rej;
                if (xhr.upload && onProgress) {
                    xhr.upload.onprogress = ev => onProgress((ev.loaded / ev.total) * 100);
                }
                xhr.send(fd);
            });
        };
        this.makeParams = (params) => params != null
            ? `?${Object.entries(params)
                .filter(([_, v]) => v != null)
                .map(([k, v]) => `${k}=${v}`)
                .join('&')}`
            : '';
    }
    withoutBody(endpoint, auth = true, method, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (auth && !this.authent.isLoggedIn) {
                return Promise.reject('must be connected');
            }
            const headers = this.makeHeaders(auth);
            const response = yield fetch(`${this.prefix}${endpoint}${this.makeParams(params)}`, {
                headers,
                method,
            });
            if (response.status === 204) {
                // @ts-ignore
                return Promise.resolve(undefined);
            }
            const json = yield response.json();
            if (!response.ok)
                return Promise.reject(json);
            if (this.log) {
                console.log('[API]', endpoint, { out: json });
            }
            return json;
        });
    }
    withBody(endpoint, data, auth = true, method) {
        return __awaiter(this, void 0, void 0, function* () {
            if (auth && this.authent.isLoggedIn == null) {
                return Promise.reject('must be connected');
            }
            const headers = this.makeHeaders(auth);
            const response = yield fetch(`${this.prefix}${endpoint}`, {
                headers,
                method,
                body: data ? JSON.stringify(data) : undefined,
            });
            const json = yield response.json();
            if (!response.ok)
                return Promise.reject(json);
            if (this.log) {
                console.log('[API]', endpoint, { out: json });
            }
            return json;
        });
    }
    withBodyNoOut(endpoint, data, auth = true, method) {
        return __awaiter(this, void 0, void 0, function* () {
            if (auth && this.authent.isLoggedIn == null) {
                return Promise.reject('must be connected');
            }
            const headers = this.makeHeaders(auth);
            const response = yield fetch(`${this.prefix}${endpoint}`, {
                headers,
                method,
                body: data ? JSON.stringify(data) : undefined,
            });
            if (!response.ok)
                return Promise.reject(response);
            if (this.log) {
                console.log('[API]', endpoint, { out: response });
            }
            return Promise.resolve(response);
        });
    }
    makeHeaders(auth) {
        const headers = new Headers();
        if (this.authent.isLoggedIn && auth) {
            headers.set('Authorization', this.authent.authHeader);
        }
        headers.set('Accept', 'application/json');
        headers.set('Content-Type', 'application/json');
        return headers;
    }
}
//# sourceMappingURL=APIProxy.js.map